import * as react from "react";
import DeviceCard from "./DeviceCard";

export function deviceCard(props) {
    return react.createElement(DeviceCard, props);
}

